import { render, staticRenderFns } from "./pictureResultNny.vue?vue&type=template&id=9d3c97de&"
import script from "./pictureResultNny.vue?vue&type=script&lang=js&"
export * from "./pictureResultNny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports